/* Founder-approved NEW Halloween sales end. Existing orders and all fulfillment UI stay intact. */
(function(){
 'use strict';
 if(window.SccHalloweenSales){window.SccHalloweenSales.apply();return;}
 const end=Date.parse('2026-11-01T06:00:00Z');
 function apply(){
  const serverEnded=!!document.querySelector('[data-halloween-sales-ended="true"]');
  if(Date.now()<end&&!serverEnded)return;
  document.querySelectorAll('[data-halloween-new-offer]').forEach(e=>e.hidden=true);
  document.querySelectorAll('[data-halloween-choice-copy]').forEach(e=>e.textContent='Pick two different Originals characters. Each comes in TRUE YOU and IMAGINE YOU. Add individual images for $1.75 each before checkout.');
  document.querySelectorAll('[data-halloween-custom-example]').forEach(e=>e.textContent='Try a profession or everyday style. Include colors and accessories. Maximum 200 characters.');
  document.querySelectorAll('[data-halloween-sales-root]').forEach(root=>{
   root.dataset.halloweenSalesEnded='true';
   root.querySelector('[data-halloween-ended-notice]')?.removeAttribute('hidden');
   root.querySelectorAll('[data-buy],[data-c12-buy],[data-c12-review]').forEach(b=>b.disabled=true);
  });
 }
 document.addEventListener('click',e=>{
  if(Date.now()<end)return;
  const button=e.target.closest?.('[data-halloween-sales-root] [data-buy],[data-halloween-sales-root] [data-c12-buy],[data-halloween-sales-root] [data-c12-review]');
  if(button){e.preventDefault();e.stopImmediatePropagation();apply();}
 },true);
 window.SccHalloweenSales={apply,end};
 apply();
 const remaining=end-Date.now();if(remaining>0)setTimeout(apply,remaining);
 window.addEventListener('focus',apply);
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')apply();});
})();
